import { render, staticRenderFns } from "./voicemail-icon.vue?vue&type=template&id=3caa7a49"
import script from "./voicemail-icon.vue?vue&type=script&lang=js"
export * from "./voicemail-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3caa7a49')) {
      api.createRecord('3caa7a49', component.options)
    } else {
      api.reload('3caa7a49', component.options)
    }
    module.hot.accept("./voicemail-icon.vue?vue&type=template&id=3caa7a49", function () {
      api.rerender('3caa7a49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/notifications/voicemail-icon.vue"
export default component.exports